import { render } from "./card-detail.vue?vue&type=template&id=01f752ca"
import script from "./card-detail.js?vue&type=script&lang=js&external"
export * from "./card-detail.js?vue&type=script&lang=js&external"

import "./card-detail.vue?vue&type=style&index=0&id=01f752ca&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__